import { useMemo } from 'preact/hooks';

export const useSwatchesGlobal = ({
    variantColors,
    variantImages,
    fallbackImage,
}) => {
  return useMemo(() => {
      if (!variantColors || !variantImages) {
        return [];
      } else {
        let swatchList = new Set();
        let images = JSON.parse(variantImages);

        variantColors.forEach(function (color, index) {
          let swatch = new Object();

          swatch.frame_color = color.replaceAll('  ', ' ');

          swatch.fallback_img = fallbackImage;

          images.forEach(function (img, index) {
            if (img.frame_color == swatch.frame_color) {
              swatch.thumbnail = img.img;
            }
          })

          if (!swatch.thumbnail) {
            swatch.thumbnail = fallbackImage;
          }

          //Grab global swatch name for display
          //Ex: product_color_blacksilver.png
          let sanitizedColorName = color.replaceAll(" ", "").toLowerCase();
          let filenameURL = `${window.Resources.searchspring.results.genericImageUrlPrefix}/product_color_${sanitizedColorName}.png`;

          swatch.swatch_image = filenameURL;
          swatchList.add(swatch);
        });

        return swatchList;
      }
  }, [
    variantColors,
    variantImages,
    fallbackImage,
  ])
}
